import { createTheme, } from '@mantine/core';

const inputLabelStyles = {
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 400,
};

export default createTheme({
  headings: {
    fontFamily: 'inherit',
  },
  components: {
    InputWrapper: {
      styles: {
        error: {
          fontSize: '0.7em',
        },
      },
    },
    TextInput: {
      styles: {
        label: inputLabelStyles,
      },
    },
    Textarea: {
      styles: {
        label: inputLabelStyles,
      },
    },
  },
});
